//export const FRONTEND_BASE_URL = 'https://martonticket.hu'
export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL ?? 'http://localhost:3200'
